module.exports = __webpack_public_path__ + "img/logo-text.eee920e5.png";